module.exports = __webpack_public_path__ + "img/signature.3cfd7a98.png";